module.exports = __webpack_public_path__ + "img/Shaman-draenei-m-70.f6393b23.gif";